if (!customElements.get('scroll-to-section')) {
  class ScrollToSection extends HTMLElement {
    constructor() {
      super();

      this.btnScroll = this.querySelector('.js-btn-scroll');
      this.section = this.closest('.shopify-section');
      this.nextSection = this.section?.nextElementSibling;

      this.btnScroll.addEventListener('click', (e) => {
        e.preventDefault();

        if (!this.nextSection) return;

        scrollTo(0, this.nextSection.offsetTop);
      });

      window.addEventListener('shopify:section:load', (e) => {
        this.section = this.closest('.shopify-section');
        this.nextSection = this.section?.nextElementSibling;
      });
    }
  }

  customElements.define('scroll-to-section', ScrollToSection);
}
